export default __webpack_public_path__ + "static/media/our-services-right-bg.976d9917.png";